import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./CotacoesEnviadas.css";
import api from '../../../services/api';
import { Grid, TextField } from '@mui/material';
import API_CONFIG from '../../../config/api.config';
import ModalItensCotacao from './ModalItensCotacao';



const CotacoesEnviadas = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Sempre pega do localStorage
  const fornecedorId = localStorage.getItem('idFornecedor');
  //console.log('ID do Fornecedor:', fornecedorId);

  useEffect(() => {
    const tipoUsuario = localStorage.getItem('tipoUsuario');
    if (tipoUsuario !== 'FORNECEDOR') {
      navigate('/');
    }
  }, [navigate]);

  const [isFornecedorMenuExpanded, setIsFornecedorMenuExpanded] = useState(false);
  const [fornecedorSearchTerm, setFornecedorSearchTerm] = useState('');
  const [fornecedorDataInicio, setFornecedorDataInicio] = useState('');
  const [fornecedorDataFim, setFornecedorDataFim] = useState('');
  const [fornecedorCurrentPage, setFornecedorCurrentPage] = useState(1);
  //const [fornecedorSolicitacoes, setFornecedorSolicitacoes] = useState(solicitacoesExemplo); // Remover estado de solicitacoes com dados de exemplo
  const [fornecedorSolicitacoesFiltradas, setFornecedorSolicitacoesFiltradas] = useState([]); // Começa vazio
  const [fornecedorLoading, setFornecedorLoading] = useState(false); // Estado de loading
  const [fornecedorPaginacao, setFornecedorPaginacao] = useState(null); // Estado para dados de paginação da API
  const [modalOpen, setModalOpen] = useState(false);
  const [cotacaoSelecionada, setCotacaoSelecionada] = useState(null);
  // Novo estado para itens da cotação
  const [itensCotacao, setItensCotacao] = useState([]);
  const [itensCotacaoLoading, setItensCotacaoLoading] = useState(false);
  const [itensCotacaoErro, setItensCotacaoErro] = useState('');

  // Função para limitar o tamanho do texto
  const fornecedorLimitarTexto = (texto, limite = 50) => {
    if (texto.length <= limite) return texto;
    return texto.substring(0, limite) + '...';
  };

  // Função para extrair o ID da solicitação do termo de busca
  const fornecedorExtrairIdSolicitacao = (termo) => {
    const id = termo.replace(/[^\d]/g, '');
    return id ? parseInt(id) : null;
  };

  // Função para formatar a data para comparação
  const fornecedorFormatarDataParaComparacao = (dataString) => {
    const dataSemHora = dataString.split(' ')[0];
    return new Date(dataSemHora);
  };

  // Extrai apenas números do termo de busca
  const fornecedorExtrairIdCotacao = (termo) => {
    const id = termo.replace(/[^\d]/g, '');
    return id ? parseInt(id) : null;
  };

  // Buscar cotações enviadas para o fornecedor via API
  const buscarCotacoesEnviadas = async (pagina = 1) => {
    if (!fornecedorId) {
      return;
    }
    try {
      setFornecedorLoading(true);
      const params = {
        page: pagina,
        per_page: 8
      };
      // Filtro por número da cotação
      if (fornecedorSearchTerm) {
        const idCotacao = fornecedorExtrairIdCotacao(fornecedorSearchTerm);
        if (idCotacao) {
          params.cotacao_id = idCotacao;
        }
      }
      // Filtros de data
      if (fornecedorDataInicio) {
        params.data_inicio = fornecedorDataInicio;
      }
      if (fornecedorDataFim) {
        params.data_fim = fornecedorDataFim;
      }
      const url = API_CONFIG.ENDPOINTS.COTACOES.LISTAR_COTACAO_ENVIADAS_FOR(fornecedorId);
      const response = await api.get(url, { params });
      const data = response.data;
      if (data && data.status && data.cotacoes) {
        setFornecedorPaginacao(data.cotacoes);
        setFornecedorCurrentPage(pagina);
      } else {
        setFornecedorPaginacao(null);
      }
    } catch (error) {
      setFornecedorPaginacao(null);
    } finally {
      setFornecedorLoading(false);
    }
  };

  // Buscar ao montar o componente (primeira página, sem filtro)
  useEffect(() => {
    buscarCotacoesEnviadas(1);
    // eslint-disable-next-line
  }, [fornecedorId]);

  // Paginação
  const fornecedorNextPage = () => {
    if (fornecedorPaginacao?.next_page_url) {
      const url = new URL(fornecedorPaginacao.next_page_url);
      const page = url.searchParams.get('page');
      buscarCotacoesEnviadas(Number(page));
    }
  };
  const fornecedorPrevPage = () => {
    if (fornecedorPaginacao?.prev_page_url) {
      const url = new URL(fornecedorPaginacao.prev_page_url);
      const page = url.searchParams.get('page');
      buscarCotacoesEnviadas(Number(page));
    }
  };

  // Monitora mudanças no menu através de um evento personalizado
  useEffect(() => {
    const handleFornecedorMenuChange = (event) => {
      setIsFornecedorMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleFornecedorMenuChange);
    return () => window.removeEventListener('menuStateChange', handleFornecedorMenuChange);
  }, []);

  const handleFornecedorViewSolicitacao = (solicitacao) => {
    navigate(`/fornecedor/inserir-cotacao/${solicitacao.SOL_ID}`, { state: { solicitacao } });
  };

  // Função para buscar itens da cotação
  const buscarItensCotacao = async (cotacaoId) => {
    setItensCotacaoLoading(true);
    setItensCotacaoErro('');
    setItensCotacao([]);
    try {
      const url = API_CONFIG.ENDPOINTS.ITENS_COTACAO(cotacaoId);
      const response = await api.get(url);
      if (response.data && response.data.status && response.data.itens) {
        setItensCotacao(response.data.itens);
      } else {
        setItensCotacaoErro('Itens não encontrados.');
      }
    } catch (error) {
      setItensCotacaoErro('Erro ao buscar itens da cotação.');
    } finally {
      setItensCotacaoLoading(false);
    }
  };

  // Ao clicar em Ver Itens, buscar itens reais
  const handleVerItens = (cotacao) => {
    setCotacaoSelecionada(cotacao);
    setModalOpen(true);
    if (cotacao?.COT_ID) {
      buscarItensCotacao(cotacao.COT_ID);
    }
  };

  //console.log('Solicitações filtradas:', fornecedorSolicitacoesFiltradas);
  //console.log('Itens atuais:', fornecedorSolicitacoesFiltradas);

  return (
    <div className={`fornecedor-CotacoesEnviadas-container ${isFornecedorMenuExpanded ? 'menu-expanded' : ''}`}>
      {/* Central Modal */}
      <div className="fornecedor-modal-wrapper">
        <h1 className="fornecedor-modal-title">Cotações Enviadas</h1>
        <div className="fornecedor-modal-content">
          <div className="fornecedor-search-container" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <input
              type="text"
              placeholder="Digite o Nº da cotação (ex: 2)"
              value={fornecedorSearchTerm}
              onChange={(e) => setFornecedorSearchTerm(e.target.value)}
              className="fornecedor-search-input"
              style={{ minWidth: 180, maxWidth: 220, width: 180 }}
            />
            <TextField
              label="Data Início"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={fornecedorDataInicio}
              onChange={(e) => setFornecedorDataInicio(e.target.value)}
              inputProps={{ max: fornecedorDataFim }}
              style={{ minWidth: 150 }}
            />
            <TextField
              label="Data Fim"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={fornecedorDataFim}
              onChange={(e) => setFornecedorDataFim(e.target.value)}
              inputProps={{ min: fornecedorDataInicio }}
              style={{ minWidth: 150 }}
            />
            <button
              className="fornecedor-search-button"
              onClick={() => buscarCotacoesEnviadas(1)}
              style={{ height: 40, marginLeft: 4 }}
            >
              PROCURAR
            </button>
          </div>

          <div className="fornecedor-cards-grid">
            {fornecedorLoading ? (
              <div className="fornecedor-loading">
                Carregando cotações...
              </div>
            ) : fornecedorPaginacao?.data && fornecedorPaginacao.data.length > 0 ? (
              fornecedorPaginacao.data.map((cotacao) => (
                <div key={cotacao.COT_ID} className="fornecedor-card">
                  <h2 className="fornecedor-card-title">Cotação #{cotacao.COT_ID}</h2>
                  <div className="fornecedor-card-content">
                    <div><strong>Status:</strong> {cotacao.COT_STATUS}</div>
                    <div><strong>Data:</strong> {cotacao.COT_DATA_VINCULACAO ? new Date(cotacao.COT_DATA_VINCULACAO).toLocaleDateString('pt-BR') : '-'}</div>
                    <div><strong>ID da Solicitação:</strong> {cotacao.COT_SOL_ID}</div>
                    <div><strong>Itens cotados:</strong></div>
                    <button
                      className="fornecedor-ver-cotacao-btn"
                      onClick={() => handleVerItens(cotacao)}
                    >
                      Ver Itens
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="fornecedor-no-results">
                Nenhuma cotação enviada encontrada.
              </div>
            )}
          </div>

          <div className="fornecedor-pagination">
            {fornecedorPaginacao && (
              <>
                {fornecedorPaginacao.prev_page_url && (
                  <button className="fornecedor-pagination-btn" onClick={fornecedorPrevPage} disabled={fornecedorLoading}>
                    Voltar
                  </button>
                )}
                <span className="fornecedor-pagination-info">
                  Página {fornecedorPaginacao.current_page} de {fornecedorPaginacao.last_page}
                </span>
                {fornecedorPaginacao.next_page_url && (
                  <button className="fornecedor-pagination-btn" onClick={fornecedorNextPage} disabled={fornecedorLoading}>
                    Próximo
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <ModalItensCotacao
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        cotacaoId={cotacaoSelecionada?.COT_ID}
      />
    </div>
  );
};

export default CotacoesEnviadas;